import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
/**for multiple select */
import "@kenshooui/react-multi-select/dist/style.css"
/**for react bootstrap table 2 */
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
/**for table pagination */
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
/**for bootstrap */
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {HashRouter as Router} from "react-router-dom";
ReactDOM.render(
  <Router basename="/SMS">
    <App/>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
